module.exports = __webpack_public_path__ + "img/cell_link.dd5273d6.svg";